export default {"src":"/_next/static/media/ico-lock.6e3ccf2a.svg","height":16,"width":12};